import { useEffect, useState } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { api } from "@/lib/api";
import { TermsBody, sectionId } from "@/components/TermsBody";
import { Loader2 } from "lucide-react";

const Toc = ({ terms }) => {
  const items = [...terms.sections, ...terms.closing_sections, { title: "Contact", id: "section-contact" }];
  return (
    <nav className="hidden lg:block lg:col-span-4 sticky top-24 self-start max-h-[calc(100vh-8rem)] overflow-y-auto pr-2" aria-label="Sections" data-testid="terms-toc">
      <p className="label-mono text-spark-teal mb-3">Sections</p>
      <ol className="space-y-1 text-sm">
        {items.map((s) => (
          <li key={s.title}>
            <a href={`#${s.id || sectionId(s)}`} className="flex gap-2 py-1 text-spark-slate hover:text-spark-teal-dark transition-colors">
              {s.n && <span className="w-6 shrink-0 text-spark-teal font-semibold">{s.n}.</span>}
              <span>{s.title}</span>
            </a>
          </li>
        ))}
      </ol>
    </nav>
  );
};

const Terms = () => {
  const [terms, setTerms] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    api.get("/terms").then((r) => setTerms(r.data)).catch(() => setError(true));
  }, []);

  return (
    <div className="min-h-screen bg-spark-floor" data-testid="terms-page">
      <Navbar />

      <div className="bg-spark-teal-deep text-white border-b-4 border-spark-yellow">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-14">
          <p className="label-mono text-spark-yellow mb-2">Spark Scooter Repairs</p>
          <h1 className="font-display uppercase tracking-tight text-4xl sm:text-5xl lg:text-6xl font-bold leading-[0.95]">{terms?.title || "Terms and Conditions of Service"}</h1>
          {terms && <p className="mt-4 text-slate-300" data-testid="terms-last-updated">Last updated: {terms.last_updated}</p>}
        </div>
      </div>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 lg:py-14">
        {error ? (
          <p className="text-spark-slate" data-testid="terms-error">We couldn't load the Terms and Conditions right now. Please refresh the page or contact us.</p>
        ) : !terms ? (
          <div className="flex justify-center py-20"><Loader2 className="size-6 animate-spin text-spark-teal" /></div>
        ) : (
          <div className="lg:grid lg:grid-cols-12 lg:gap-10">
            <Toc terms={terms} />
            <div className="lg:col-span-8 min-w-0">
              <TermsBody terms={terms} />
            </div>
          </div>
        )}
      </main>

      <Footer />
    </div>
  );
};

export default Terms;
